export default __webpack_public_path__ + "static/media/i-scan_ins.595e9d74.svg";